import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    theme
  } = useTheme();
  const investorLoginUrl = 'https://adfs4.sts.altareturn.com/adfs/ls/?wa=wsignin1.0&wtrealm=urn%3aportal%3aracecapital&wctx=https%3a%2f%2fracecapital.altareturn.com%2f_layouts%2f15%2fAuthenticate.aspx%3fSource%3d%252F&wreply=https%3a%2f%2fracecapital.altareturn.com%2f_trust%2fdefault.aspx';
  const pitchUsUrl = 'https://airtable.com/appMNWbdHmSVm3l1M/shruyLbAMcJUdRUj6';
  return <nav className="w-full py-6 px-6 md:px-12 bg-white/80 backdrop-blur-md border-b border-gray-200/50 transition-colors fixed top-0 z-50" data-id="element-67">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-68">
        <div className="flex items-center" data-id="element-69">
          <Logo data-id="element-70" />
        </div>
        <div className="hidden md:flex items-center space-x-10" data-id="element-71">
          <NavLink to="/how-we-invest" data-id="element-72">How We Invest</NavLink>
          <NavLink to="/how-we-help" data-id="element-73">How We Help</NavLink>
          <NavLink to="/companies" data-id="element-74">Portfolio</NavLink>
          <NavLink to="/team" data-id="element-75">Team</NavLink>
          <a href={investorLoginUrl} target="_blank" rel="noopener noreferrer" className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors" data-id="element-76">
            Investor Login
          </a>
          <a href={pitchUsUrl} target="_blank" rel="noopener noreferrer" className="bg-red-600 hover:bg-red-700 text-white font-medium py-2.5 px-7 rounded-lg transition-all hover:shadow-lg hover:shadow-red-600/20" data-id="element-77">
            Pitch Us
          </a>
        </div>
        <div className="md:hidden flex items-center" data-id="element-78">
          <button className="text-[#070707]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-79">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-80" /> : <MenuIcon className="h-6 w-6" data-id="element-81" />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileMenuOpen && <div className="md:hidden mt-6 pb-4" data-id="element-82">
          <div className="flex flex-col space-y-4" data-id="element-83">
            <MobileNavLink to="/how-we-invest" onClick={() => setMobileMenuOpen(false)} data-id="element-84">
              How We Invest
            </MobileNavLink>
            <MobileNavLink to="/how-we-help" onClick={() => setMobileMenuOpen(false)} data-id="element-85">
              How We Help
            </MobileNavLink>
            <MobileNavLink to="/companies" onClick={() => setMobileMenuOpen(false)} data-id="element-86">
              Portfolio
            </MobileNavLink>
            <MobileNavLink to="/team" onClick={() => setMobileMenuOpen(false)} data-id="element-87">
              Team
            </MobileNavLink>
            <a href={investorLoginUrl} target="_blank" rel="noopener noreferrer" className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors block px-4 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-88">
              Investor Login
            </a>
            <a href={pitchUsUrl} target="_blank" rel="noopener noreferrer" className="bg-red-600 hover:bg-red-700 text-white font-medium py-2.5 px-7 rounded-lg transition-all hover:shadow-lg hover:shadow-red-600/20 w-full block text-center" onClick={() => setMobileMenuOpen(false)} data-id="element-89">
              Pitch Us
            </a>
          </div>
        </div>}
    </nav>;
};
const Logo = () => {
  return <Link to="/" className="flex items-center" data-id="element-90">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9QqUfvRDGwG7W9qysjtvXP/RC-Logo_01-PositiveRGB.png" alt="Race Capital Logo" className="h-10" data-id="element-91" />
    </Link>;
};
const NavLink = ({
  to,
  children,
  className = ''
}) => <Link to={to} className={`text-[#070707] hover:text-red-600 font-medium text-sm transition-colors ${className}`} data-id="element-92">
    {children}
  </Link>;
const MobileNavLink = ({
  to,
  children,
  onClick
}) => <Link to={to} className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors block px-4 py-2" onClick={onClick} data-id="element-93">
    {children}
  </Link>;